var mobileWidth = 640;
var fullWidth = 990;

function getMobileWidth() {
	return mobileWidth;
}

function getFullWidth() {
	return fullWidth;

}



(function ($) {

/********************
	TEASER 
**********************/

$.fn.teaser = function (ms) {
   var slides = this.find(".main");
	var tabWindow = this.find(".tabwindow");
	var tabsList = this.find("#tabs");
	var tabs = tabsList.children("li");
	var pointer = this.find("#pointer");
   var itemcount = slides.length;
   var tabHeight = tabs.first().height();
	 
	var currentPos = 0;
   delaySlide();
   
	var tick;
	
	
   function delaySlide() {
	   delay = ms;
	   tick = setInterval(function () {
		   //tabs.get(i).show();
		   clearInterval(tick);
		   i = currentPos;
		   i++;
		   if (i>=itemcount) {
			   i=0;
		   }
		   gotoSlide(i);
	   },delay);
	}
   
	function gotoSlide(i) {
		//console.log(slides.get(i));
		$(slides.get(currentPos)).fadeOut(1000);
		$(slides.get(i)).fadeIn(1000).css("display: block");
		currentPos = i;
		delaySlide(ms);
		var tabPosition = $(tabs.get(i)).position();
		pointer.animate({
			left: tabPosition.left + "px"
		});
	}
	 
	 /*
	 
   $(".arrow.right").click(function() {
	   clearInterval(tick);
	   next = currentPos+1;
	   if (next>=itemcount) {
		   next=0;
	   }
	   gotoSlide(next);
   });
 
   $(".arrow.left").click(function() {
	   clearInterval(tick);
	   previous = currentPos-1;
	   if (previous<0) {
		   previous=itemcount-1;
	   }
	   gotoSlide(previous);
   });
   
   */
	
	//console.log(tabs);

	tabs.click(function() {
		  clearInterval(tick);
		  gotoSlide($(this).index()-1);
	});
	
	this.find("#teasermore").click(function() {
		  //console.log('tabslist margin:',parseInt(tabsList.css("margin-top")));
		  var topMargin = parseInt(tabsList.css("margin-top"));
		  //console.log('marginlimit: ',tabHeight);
		  if (topMargin>(-tabHeight*(itemcount-1))) {
			  //console.log('posuvam');
			  tabsList.css("margin-top",parseInt(tabsList.css("margin-top"))-tabHeight);
			  //console.log(tabsList.css("margin-top"));
		  }
	});
 
};

/***************
 * CAROUSEL
****************/

$.fn.carousel = function(maxW) {

	var elem = this;
	var items = $(this).find(".items");
	
	var margin = 0;
	var maxMargin = 0;
	var itemWidAbs = 0;
	var numItems;
	
	
	var init = function() {
		margin = 0;
		var itemWindow = elem.find(".item-window");
		//console.log('window elem: ',itemWindow);
		var windowW = itemWindow.innerWidth(); // window width;
		//console.log('parrent of visible width',elem.parent().innerWidth());
		// if carousel is currently hidden, we can't detect width of item window
		// (happens only after additional init() call, e.g. after browser window resize)
		// item-window and parent of carousel elem cannot be hidden
		if (itemWindow.is(":hidden")) {
			//console.log('parrent of hidden width',elem.parent().innerWidth());
			var windowWPerc = itemWindow.css('width');
			// trim % sign
			windowWPerc = windowWPerc.substring(0, windowWPerc.length-1);
			//console.log('itemwindow css width',Number(windowWPerc));
			windowW = Math.round(elem.parent().innerWidth()*(windowWPerc/100));
			//console.log('hidden window width: '+windowW);
		}
			
		//console.log('window: '+elem.attr("id")+' windowwidth: '+windowW);
		numItems = Math.ceil(windowW/maxW);
		//console.log('numitems: '+numItems);
		items.attr("style", '');
		var itemWidRel = (100 / numItems)  + "%";
		//console.log('itemWidRel: '+itemWidRel);
		//elem.find(".item").css("width",itemWidRel);
		//itemWidAbs = itemWindow.find(".item").first().outerWidth();
		//console.log('normal window '+elem.attr("id")+' item width: '+itemWidAbs);
		/*if (itemWindow.is(":hidden")) {
			
			var itemClone = itemWindow.find(".item").first().clone().appendTo("<div>");
			itemWidAbs = itemClone.outerWidth();
			console.log('hidden window '+elem.attr("id")+' item width: '+itemWidAbs);
		}*/
		//console.log('itemWidAbs: '+itemWidAbs);
		itemWidAbs = windowW/numItems;
		elem.find(".item").css("width",itemWidAbs);
		var totalWidth = itemWidAbs * (items.find(".item").length+1);
		maxMargin = itemWidAbs * (items.find(".item").length - numItems - 1);
		//console.log('totalwidth pre '+elem.attr("id")+': '+totalWidth+' numitems: '+numItems+' windowW: '+windowW+' items length: '+items.find(".item").length);
		
		items.css("width", totalWidth + "px");
	};
	
	// bind resize event and reinit carousel only if stopped resizing for 100ms
	
	triggerAfterResizeDelay(init);
  
	var triggerEvent = "tap";
	if ($(document).width()>mobileWidth) {
		triggerEvent = "click";
	}
	
	this.find(".arrow.right").on(triggerEvent, function () {
		  slide("right",items);
	});

	this.find(".arrow.left").on(triggerEvent, function () {
		  slide("left",items);
	});
	
	 var slide = function (direction,items) {
		if (direction == "right" && margin >= (-maxMargin)) {
			//console.log('sliding right');
			//console.log(itemWidAbs);
			items.animate({
				 "margin-left": margin - itemWidAbs + "px",
			}, 300);
			margin -= itemWidAbs;
		} else if (direction == "left" && margin < 0) {
			items.animate({
				 "margin-left": margin + itemWidAbs + "px",
			}, 300);
			margin += itemWidAbs;
		}
		updateArrows();
	 };

	var updateArrows = function () {
		if (margin == -maxMargin) {
			elem.find(".arrow.right").addClass("inactive");
		} else {
			elem.find(".arrow.right").removeClass("inactive");
		}
		if (margin === 0) {
			elem.find(".arrow.left").addClass("inactive");
		} else {
			elem.find(".arrow.left").removeClass("inactive");
		}
	};
	//console.log(this);
	 

	 
	init();
	
	// init hammer gestures
	if (elem[0]) {
		new Hammer(elem[0], { dragLockToAxis: true }).on("release dragleft dragright swipeleft swiperight", handleHammer);
	}
   
	
	function handleHammer(ev) {
		// disable browser scrolling
		ev.gesture.preventDefault();

		switch(ev.type) {
			 case 'dragright':
			 case 'dragleft':
				  // stick to the finger
				  var pane_offset = margin;
				  var drag_offset = ((100/itemWidAbs)*ev.gesture.deltaX) / numItems;

				  // slow down at the first and last pane
				  /*
				  if((current_pane == 0 && ev.gesture.direction == "right") ||
						(current_pane == pane_count-1 && ev.gesture.direction == "left")) {
						drag_offset *= .4;
				  }
					*/
				  //setContainerOffset(drag_offset + pane_offset);
				  break;

			 case 'swipeleft':
				  slide("right",items);
				  ev.gesture.stopDetect();
				  break;

			 case 'swiperight':
				  slide("left",items);
				  ev.gesture.stopDetect();
				  break;

			 case 'release':
				  // more then 50% moved, navigate
				  if(Math.abs(ev.gesture.deltaX) > itemWidAbs/2) {
						if(ev.gesture.direction == 'right') {
							slide("left",items);
						} else {
							slide("right",items);
						}
				  }
				  else {
						//self.showPane(current_pane, true);
				  }
				  break;
		}
	}

	return this;
	
};


$.fn.popup = function(elem) {
	var popup = $(elem);
	var popupHidden = true;
	
	if ($(document).width()>getMobileWidth()) {
		  
		$(this).children("a").unbind();
		$(this).off().hover(
			function() {
				popup.stop().slideDown(100,
					function() {
						popup.attr('style','');	
					});
				
			},
			function () {
				popup.stop().slideUp(100);
			}
		);
		
	} else {
		$(this).off();
		$(this).children("a").unbind().on("click tap", function(e) {
			e.preventDefault();
			//console.log('popup mobile slide');
			if (popupHidden) {
				$(this).addClass('opened');
				popup.slideDown();
				popupHidden = false;
			} else {
				$(this).removeClass('opened');
				popup.slideUp();
				popupHidden = true;
			}
		});
	}
};


/*************************/
/* floater */
/*************************/

$.fn.floater = function(time,easing) {

	var floatElem = $(this);
	var offset = $(floatElem).offset();
	var topPadding = 0;
	
	var heightTopMenu = $('#top_menu').outerHeight();
	var heightHeader = $('header').outerHeight();
	
	var cartOffsetToFloat = heightTopMenu + heightHeader;
	var cartOffsetDefault = heightTopMenu;

	time = (time !== undefined) ? time : 0;
	easing = (time !== undefined) ? easing : 'linear';

	//floatElem.off();

		$(window).scroll(
			function () {
				if ($(document).width()>getMobileWidth()) {
					//console.log('cartOffsetToFloat: ',cartOffsetToFloat);
					cartOffsetToFloat = heightHeader;
					cartOffsetDefault = 0;
					//cyclone3.log(cartOffsetDefault + ' ' + cartOffsetToFloat)
					//cyclone3.log($(window).scrollTop())
					//console.log('cartOffsetToFloat: '+cartOffsetToFloat);
					//if ($(window).scrollTop() > offset.top + 100) {
					
					
					
					if ($(window).scrollTop() > cartOffsetToFloat) {
						 //console.log('animating');
						//console.log('offset.top: '+offset.top);
						//console.log('cartOffsetDefault: '+cartOffsetDefault);
						//console.log('scrollTop: '+$(window).scrollTop());
						$(floatElem).addClass('scrolled');
						
						/*
						 // use only for eased motion, problematic on resize
						 $(floatElem).stop().animate({
									marginTop: $(window).scrollTop() - offset.top + cartOffsetDefault
								},
								time,
								easing
						);*/
						//console.log('cart margin: '+$(sidebar).css("margin-top"))
					} else {
						(floatElem).stop().animate({
									marginTop: cartOffsetDefault
								},
								time,
								easing,
								function () {
									$(floatElem).removeClass('scrolled');
								}
						);
					}
				}
			});

};

$.fn.fillWidth = function(parent) {
	 
	if ($(document).width()>480) {
		var elems = $(this);
		var parentW = $(parent).width();
		var elemsW = 0;
		$(elems).each(function(i,e) {
			//console.log($(e).outerWidth(true));
			elemsW+=$(e).outerWidth(true);
		});
		//console.log(elemsW);
		//console.log(parentW);
		var wToAdd = (parentW - elemsW)/$(elems).length;
		//console.log(wToAdd);
		$(elems).each(function(i,e) {
			//console.log('before: ',$(e).outerWidth(true));
			$(e).width("20%");
			
			//console.log('after: ',$(e).outerWidth(true));
		});
		
		var first = $(elems).first();
		//first.width(first.width()+parseInt(first.css("margin-left")));
		first.css("margin-left",0);
		var last = $(elems).last();
		//console.log(last.width());
		//last.width(last.width()+parseInt(last.css("margin-right")));
		//console.log(last.width());
		last.css("margin-right",0);
	}
};

$.fn.addToBasket = function() {
	this.each(function(){
		var img = $(this).parents(".item").find('img:first');
		//console.log('parent:',$(this).parents(".item"));
		$(this).click(function(){
			flyToElement($(img), $('#basket-scroll'), $(this).data("product-id"));
			return false;
		});

  });
	function flyToElement(flyer, flyingTo, productID, callBack /*callback is optional*/) {
		var $func = $(this);
		//console.log('flyer',flyer);
		var divider = 3;

		var flyerClone = $(flyer).clone();
		$(flyerClone).css({
			position: 'absolute',
			top: $(flyer).offset().top + "px",
			left: $(flyer).offset().left + "px",
			opacity: 1,
			'z-index': 1000
		});
		$('body').append($(flyerClone));

		var gotoX = $(flyingTo).offset().left + ($(flyingTo).width() / 2) - ($(flyer).width()/divider)/2;
		var gotoY = $(flyingTo).offset().top + ($(flyingTo).height() / 2) - ($(flyer).height()/divider)/2;

		$(flyerClone).animate({
			opacity: 0.4,
			left: gotoX,
			top: gotoY,
			width: $(flyer).width()/divider,
			height: $(flyer).height()/divider
		}, 700,
		function () {
			 $(flyerClone).fadeOut('fast', function () {
					$(flyerClone).remove();
					$.ajax({
						type: "POST",
						url: "basketresponse.html",
						data: { productID: productID, action: "addToBasket"},
						success: function(data) {
							 
							 //console.log($(data).find("#ajax-content"));
							 if($("#ajax-content",data)) {
									$("#basket").html($(data).find("#basket").html());
							 }
						},
						error: function(xhr,status,error) {
							 //console.log(xhr,status,error);
						},
						dataType: 'html'
					});  
					
			 });
		});
	}
};

/*************************/
/* dropdown */
/*************************/

	$.fn.dropdown = function(target) {
		this.click(function() {
			//$(this).off("click");
			var self = $(this);
			target.toggle(1, function()  {
				//self.on("click");
				$(document).click(function(event) {
				
				
				if(!$(event.target).closest($(target)).length) {
					if($(target).is(":visible")) {
						$(target).hide(1, function() {
							$(document).off("click");
							//self.on("click");
						});
					}
				}
				});
				
			});
		});
	};
	

/*************************/
/* tabs */
/*************************/

	$.fn.tabs = function(target) {
		var tabsWrapper = this;
		var tabSwitchers = tabsWrapper.find(".tabs li a");
		//console.log(tabSwitchers);
		var tabsContents = tabsWrapper.siblings(".content");
		//console.log(tabsContents)
		//console.log(this);
		tabSwitchers.click(function() {
			if (!$(this).hasClass("active")) {
				$(tabSwitchers).add(tabsContents).removeClass("active");
				$(this).addClass('active');
				var tabContent = $("#"+$(this).data("target"));
				tabContent.addClass("active");
			}
			
		});
		
	};

/*************************/
/* filter related */
/*************************/

	var priceSliderChange = false;

	// init for buttonset
	$.fn.filterButtonset = function(callback) { 
		$(this).buttonset({
			create: function( event, ui ) {
				$(this).setFilterBoxes();
				if (typeof callback !== "undefined" ) {
					callback();
				}
			}
		});
	};
	
	$.fn.setFilterBoxes = function() {
		$(this).find("input:checked").each(function(i,e) {
			var label = $("[for="+$(e).attr("id")+"]");
			var filterFor = $(this).attr("id");
			var parent = $(this).parents(".content").siblings(".title").text().trim();
			addBox(label,filterFor,parent);
		});
		
		$("#remove-all-filters").unbind().click(function() {
			
			$(".filter label.ui-state-active").each(function(i,e) {
				var filterFor = $(e).attr("for");
				removeBox(filterFor,$(e),true);
			});
			removeBox("filter-price-range",[],true);
			$("#remove-all-filters").hide();
			priceSliderChange = false;
		});

		$(this).find("label").click(function() {
			var filterFor = $(this).attr("for");
			var parent = $(this).parents(".section").find(".title").text().trim();
			if($(this).hasClass("ui-state-active")) {
				removeBox(filterFor,$(this));
			} else {
				addBox($(this),filterFor,parent);
			}
			loadFilteredResults();
		});
	};
	
	function addBox(checkbox,filterFor,parent) {
		var value = checkbox.text();
		if (!value) {
			value = checkbox.val();
		}
		var filterBoxTemplate = '<div class="filterbox"><span class="value">'+value+'</span><a href="javascript:;" class="remove">x</a></div>';
		
		//console.log('value',value);
		var boxToAdd = $(filterBoxTemplate).attr("data-filter-for",filterFor);
		var paramName = "filter_" + checkbox.data("param-name") + "[]";
		var paramValue = String(checkbox.data("param-value"));
		if (typeof paramValue !== "undefined" && (paramName != "filter_price-range[]")) {
			if(typeof window.filterParams[paramName] === "undefined") {
				//console.log('creating new param');
				window.filterParams[paramName] = [];
			}
			if ($.inArray(paramValue, window.filterParams[paramName]) < 0) {
				window.filterParams[paramName].push(paramValue);
			}
		}
		
		//console.log('param name',paramName);
		//console.log('checkbox',checkbox);
		$("#remove-all-filters").show();
		
		boxToAdd.prepend('<span class="section">'+parent+': </span>');
		
		//console.log('boxToAdd',boxToAdd);
		//console.log('parent',parent);
		$("#selected-filters").append(boxToAdd);
		
		// "x" button
		boxToAdd.find(".remove").click(function() {
			removeBox(filterFor,$('label[for="'+$(this).parent().data('filter-for')+'"]'),true);
		});
		
	}
		
	function removeBox(filterFor,checkbox,refresh) {
		$('[data-filter-for="'+filterFor+'"]').remove();
		
		//console.log('checkbox length',checkbox.length);
		if (checkbox.length > 0 && checkbox.data("param-name")) {
			var paramName = "filter_" + checkbox.data("param-name") + "[]";
			var paramValue = String(checkbox.data("param-value"));
			
				// console.log('checkbox',checkbox);
				// console.log('param name',paramName);
				// console.log('param value',paramValue);
				// console.log('filter param [name]',filterParams[paramName]);
				// console.log('checkbox',checkbox);
				// console.log('filter params before',window.filterParams[paramName]);
				// console.log("inarray index "+$.inArray(paramValue, window.filterParams[paramName]));
				window.filterParams[paramName].splice( $.inArray(paramValue, window.filterParams[paramName]),1);
			if (window.filterParams.brand && paramName == "filter_brands[]") {
				window.filterParams.brand.splice( $.inArray(paramValue, window.filterParams.brand),1);
			}
		}
		if ($("#selected-filters .filterbox").length===0) {
			$("#remove-all-filters").hide();
		}
		if (refresh) {
			//console.log('filter for: ',filterFor);
			var filterForElem = $('#'+filterFor);
			filterForElem.removeAttr("checked");
			filterForElem.parents(".ui-buttonset").buttonset("refresh");
			//console.log('filterForElem',filterForElem);
			//$("#"+filterFor).slider("refresh");
			//console.log($("#"+filterFor).data());
			if (priceSliderChange && filterFor == "filter-price-range") {
				filterForElem
					.slider("values", 0, filterForElem.slider("option", "min") )
					.slider("values", 1, filterForElem.slider("option", "max") );
				priceSliderChange = false;	
			}
		}
		
		
		loadFilteredResults();
	}

	// init for slider
	$.fn.filterSlider = function(reset, priceMin, priceMax, priceFilteredMin, priceFilteredMax) {
		// console.log('creating slider for price filter, min='+priceMin+' max='+priceMax);
		// console.log('price filtered min='+priceFilteredMin+' max='+priceFilteredMax);
		var self = $(this);
		var parent = $(this).parents(".section").find(".title").text().trim();
		// console.log("max je "+Number(priceMax)+1);
		$(this).slider({
			range: true,
			min: Number(priceMin),
			max: Number(priceMax)+1,
			values: [ Number(priceFilteredMin), Number(priceFilteredMax)+1 ],
			create: function(e,ui) {
				//$(this).setFilterBoxes();
				
				var displayMin = formatPrice(priceFilteredMin, cyclone3.currency_symbol, false, true);
				var displayMax = formatPrice((Number(priceFilteredMax)+1), cyclone3.currency_symbol, false, true);
				$("#filter-price-number").val(displayMin + " - " + displayMax);
				if ((Number(priceMin) != Number(priceFilteredMin)) || (Number(priceMax) != Number(priceFilteredMax))) {
					ui.values = [];
					ui.values[0] = priceFilteredMin;
					ui.values[1] = priceFilteredMax;
					updateSliderTexts(ui);
				}
			},
			slide: function(e,ui) {
			},
			change: function(e,ui) {
				updateSliderTexts(ui);
				loadFilteredResults();
			}
		});
		
			//updateSliderTexts();
		
		if (reset=="reset") {
			$("#box-filter-price-range").remove();
			/*($(".filter .ui-slider")
				.slider("values", 0, $(".filter .ui-slider").slider("option", "min") )
				.slider("values", 1, $(".filter .ui-slider").slider("option", "max") );*/
		}

		function updateSliderTexts(ui) {
			/*var min = $(this).slider("values",0);
			var max = $(this).slider("values",1);*/
			var rangeText = Math.floor(ui.values[0]) + " " + cyclone3.currency_symbol + " - " +  Math.floor(ui.values[1]) + " " + cyclone3.currency_symbol;
			//console.log('slider change',priceSliderChange);
			if (!priceSliderChange) {
				addBox($("#filter-price-number"),"filter-price-range",parent);
				//$("#box-filter-price-range").append('<span id="box-filter-price-range-text"></span>');
			}
			$("#filter-price-number").val(rangeText);
			$("[data-filter-for=filter-price-range] .value").html(rangeText);
			priceSliderChange = true;
			window.filterParams.price_min = Math.floor(ui.values[0]);
			window.filterParams.price_max = Math.floor(ui.values[1]);
		}
		
	};
	
	$.fn.filterSortBy = function() {
		var self = $(this);
		
		var options = $(this).buttonset().find("label");
		
		$.each(options, function(i,e) {
			$(e).click(function(tgt) {
				currentTgt = $(tgt.currentTarget);
				window.filterParams.sortby = currentTgt.attr("data-sortby-option");
				optionName = currentTgt.find('span').html();
				$("#filter-sortby").text(optionName);
				$("#filter-sortby-options").hide();
				$(document).off("click");
				loadFilteredResults();
			});
		});
	};
	
	// simplier variant with plain <select>
	$.fn.filterSortBySelect = function() { 
		
		$(this).change(function() { 
			var currentTgt = $(this).find(":selected");
			var optionName = currentTgt.html();
			window.filterParams.sortby = currentTgt.attr("data-sortby-option");
			console.log('sorting');
			loadFilteredResults();
		});
	};

	/* ========================
		UNBIND EVENT ON FULLSIZE
	   ======================== */
	
	$.fn.unbindEventOnFull = function(event,fnc) {
		var elem = $(this);
		
		var bindIfSize = function() {
			if ($(document).width()>=getFullWidth()) {
				elem.unbind(event,fnc);
			} else {
				elem.unbind(event,fnc);
				elem.bind(event,fnc);
			}
		};
		bindIfSize();	
		$(window).resize(function() {
			bindIfSize();
		});
	};

	$.fn.basketSpinner = function() {
		var elem = $(this);

		elem
			.spinner({
				min: 1,
				numberFormat: "n"
			})
			.bind("keydown", function (event) {
				event.preventDefault();
			})
			.focus(function () {
				$(this).blur();
			});

	};

	$.fn.openingSection = function(action) {
		var elem = $(this);
		if(action == "open") {
			if (elem.children(".content").is(":hidden")) {
				$(".section .content").slideUp();
				$(".section").removeClass("enabled").addClass("disabled");
				elem.addClass("enabled").removeClass("disabled");
				elem.children(".content").slideDown();
			}
		}
	};

	// EPIC AUTOCOMPLETE SEARCH

	$.fn.epicAutocompleteSearch = function() {

		$.ui.autocomplete.prototype._renderItem = function( ul, item){
			var term = this.term.split(' ').join('|');
			var re = new RegExp("(" + term + ")", "gi") ;
			var t = item.label.replace(re,"<strong>$1</strong>");
			var img;
			if (item.img_url) { 
				img = $('<img src="'+item.img_url+'">');
			}
			return $( '<li></li>' )
			  .data( "item.autocomplete", item )
			  .append( '<a href="'+item.url+'">' + t +  '</a>' )
			  .prepend(img)
			  .appendTo( ul );
			};

			var focused;

			$.widget( "custom.catcomplete", $.ui.autocomplete,
			{
				_create: function() {
				  this._super();
				  this.widget().menu( "option", "items", "> :not(.ui-autocomplete-category)" );
				},
				_renderMenu: function( ul, items ) {
				  var that = this,
					currentCategory = "";

				  $.each( items, function( index, item ) {
					 var li;
					  var aria_label = item.category + " : " + item.label;
					 if ( item.category != currentCategory ) {
						ul.append( "<li class='ui-autocomplete-category'><span>" + item.category + "</span></li>" );
						currentCategory = item.category;
					 }
					 li = that._renderItemData( ul, item );
					 if ( item.category ) {
						li.attr( "aria-label", aria_label );
					 }
				  });
					var allUrl = $(that.element).parents("form").attr("action")+"?q="+that.term;
					var allText = $("#search-all-results").text();
					var clone = $("#search-all-results").clone()
						.attr("id","search-all-results-clone")
						.css("display","block")
						.attr("href",allUrl)
						.appendTo(ul)
						.data(
							{
								'ui-autocomplete-item' : {
									'url':allUrl,
									'label':allText,
									'value':that.term
								}
							}
						)
						.find("#search-results-string")
							.attr("id","search-results-string-clone")
							.html(that.term);
				}
			});

			$(this).catcomplete({

				source: function(request, response) {
					/* local results: */

					var localResults = $.ui.autocomplete.filter(autocomplete_static_data, request.term);
					$("#search-loader").css("display","block");

					response(localResults);

					//$("#search-loader").hide();
					/* Remote results: */
					$.ajax({
						url: cyclone3.domain+"?type=ajax_autocomplete_search&q="+request.term+" #ajax-body",
						success: function(data) {
							jsonData = $(data).filter("#ajax-body").text();
							response(localResults.concat($.parseJSON(jsonData)));
							$("#search-loader").hide();
						}
					});
				},
				// to open url also on keyboard navigation (pressing return)
				select: function(event, ui) {
					var url = ui.item.url;
					window.location.href = url;
				}

			});
	};
	
	$.fn.wrapDecimals = function() {
		var $this = $(this);
		if ($this.length > 0) {
			var pattern = /(\d+\,)(\d\d)/;
			var match = pattern.exec($this.html());
			var newHtml = $this.html().replace(match[1],'').replace(match[2],'');
			$this.html(match[1]+'<span class="decimal">'+match[2]+newHtml+'</span>');
		}
	};
	
	$.fn.colorSwitcher = function(callback) {
		var $this = $(this);
		if ($this.length > 0) {
			var	$allBtns = $(this).find(".color-modification");
			var $galleries = $(".gallery");
			var activeColor = $allBtns.filter(".active").data("color-name");
			//var animating = false;
			var hashColor = window.location.hash.substring(1);
			
			
			var setActiveBtn = function(color) {
				$this
					.find(".color-modification")
					.removeClass("active")
					.filter("[data-color-name='"+color+"']")
					.addClass("active");
			};
		
			var showGalleryByColor = function(color) {
				
				$galleries.filter(":visible")
					.fadeOut(200);
				var $galToDisplay = $galleries.filter("."+color)
					.fadeIn(200,function() {
						$(this).css("display","inline-block");
						callback(); // we need to call height recalculation 
					});
			};
			
			var filterSizes = function(color) {
				var $modifications = $(".product-view .modifications");
				
				
				var $modifToHide = $modifications.find("option[data-dummy!='1']").map(function() {
            		return $(this).parent('span').length === 0 ? this : null;
        		}).wrap('<span></span>');
				
				$modifications.find("span:not(.title)").hide();
				
				var $shown = $modifications.find("[data-color='"+color+"']").map(function() {
            		return $(this).parent('span').length === 0 ? this : $(this).unwrap();
        		});
			};
			
			// init active color by hash or first
			var initColor = $allBtns.first().data("color-name");
			if (hashColor) {
				initColor = hashColor;
			}
				
			activeColor = initColor;
			//showGalleryByColor(initColor);
			//setActiveBtn(initColor);
			//filterSizes(initColor);
			
			// $allBtns
			// .click(function(e) {
			// 	var targetHref = e.currentTarget.getAttribute("href");
			// 	//console.log('target href',targetHref);
			// 	//history.replaceState(undefined, undefined, targetHref);
			// 	var color = $(this).data("color-name");
			// 	if (color != activeColor){
			// 		showGalleryByColor(color);
			// 		filterSizes(color);
			// 		setActiveBtn(color);
			// 		activeColor = color;
			// 	}
			// });
		}
	};
	
	$.fn.galleryImgSwitcher = function(onSwitch) {

		if (typeof onSwitch === "undefined") {
			onSwitch = function() {};
		}

		var $this = $(this); // should be gallery element, eventually for every color
		
		if ($this.length > 0) {
			
			// INIT 
			var animating = false;
			window.imgsLoaded = true;
			var $moreImages = $this.find(".more-images");
			if ($moreImages.length < 1) {
				$moreImages = $('<div class="more-images"></div>').appendTo($this);
			}
			// duplicate main image into small
			$this.find(".img.big").clone()
				.attr("data-image-semi-format-path",$(this).find("img").attr("src"))
				.removeClass("big")
				.addClass("selected")
				.prependTo($moreImages);
			
			$this.find(".img.big").click(function(e) {
				e.preventDefault();	
			});
			
			$moreImages.find(".img")
				.click(function(e) {
					e.preventDefault();
					onClick(this);
				});
			
			var bigHeight = $this.children(".big").height();
			// console.log('bigheight is'+bigHeight);

			var onClick = function(image) {
				if (window.imgsLoaded && !animating) {
					var swapImages = function() {
						// fade in and out, set absolute positions and resolve corresponding heights

						$currentBig
							.css({"position":"absolute"})
							.fadeOut(200,function() {
								animating = false;
							});

						// $gallery.find(".more-images")
						// 	.css({ 
						// 		"position":"absolute",
						// 		"top":bigHeight
						// 	});
						$bigToShow
							.fadeIn(200,function() {
								$bigToShow.css({'position':'relative'})
									// hack for safari which was unable to recalculate size of element without change in dimensions of parent parent
									.parent().parent().css({"width":"100%"});
								animating = false;
								onSwitch();
							});
					};

					var $this = $(image);
					var $gallery = $this.parents('.gallery');

					var $currentSelected = $gallery.find(".img.selected");
					var $currentBig = $gallery.find('.img.big[data-image-ID="'+$currentSelected.attr('data-image-ID')+'"]');
					var $bigToShow = $gallery.find('.img.big[data-image-ID="'+$this.attr('data-image-ID')+'"]');

					var imgsLoaded = false;

					animating = true;

					$gallery.find(".img").removeClass("selected");
					$this.addClass("selected");
					
					$currentBig.trigger('zoom.stop');



					// big image is not created yet, create it
					if($bigToShow.length < 1) {
						var $loader = $gallery.find(".loader").show();

						$bigToShow = $currentBig.clone().hide()
							.appendTo($gallery.find("div.big"))
								.attr("href",$this.attr("href"))
								.attr("data-image-ID",$this.attr("data-image-ID"));



						$bigToShow.find("img")
						.attr('src',$this.attr("data-image-semi-format-path"));
						// insert fullsize image to dom
						// because we need to initialize zoom after fullsize is loaded
						window.imgsLoaded = false;
						console.log('idem nacitavat ',$this.attr("data-image-semi-format-path"));
						var $img = $("<img>")
							.attr("src",$this.attr("data-image-semi-format-path"))
							.hide()
							.appendTo("body")
							.load(function() {
								window.imgsLoaded = true;
								//bigHeight = $bigToShow.height();
								console.log('loader',$loader);
								$loader.hide();
								swapImages();
								
								$bigToShow.zoom({
									url:$this.attr("href")
								});
								$(this).remove();
							});
							$img.filter(".zoomImg");
						//$img.remove();
					} else {
						swapImages();
					}
					onSwitch();
					$bigToShow.click(function(e) {e.preventDefault();});
				} 
			};
		}
	};
	
// Core Zoom Logic, independent of event listeners.
	$.zoom = function(target, source, img, magnify) {
		var targetHeight,
			targetWidth,
			sourceHeight,
			sourceWidth,
			xRatio,
			yRatio,
			offset,
			$target = $(target),
			position = $target.css('position'),
			$source = $(source);

		// The parent element needs positioning so that the zoomed element can be correctly positioned within.
		$target.css('position', /(absolute|fixed)/.test(position) ? position : 'relative');
		$target.css('overflow', 'hidden');

		img.style.width = img.style.height = '';

		$(img)
			.addClass('zoomImg')
			.css({
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: 0,
				width: img.width * magnify,
				height: img.height * magnify,
				border: 'none',
				maxWidth: 'none',
				maxHeight: 'none'
			})
			.appendTo(target);

		return {
			init: function() {
				targetWidth = $target.outerWidth();
				targetHeight = $target.outerHeight();

				if (source === $target[0]) {
					sourceWidth = targetWidth;
					sourceHeight = targetHeight;
				} else {
					sourceWidth = $source.outerWidth();
					sourceHeight = $source.outerHeight();
				}

				xRatio = (img.width - targetWidth) / sourceWidth;
				yRatio = (img.height - targetHeight) / sourceHeight;

				offset = $source.offset();
			},
			move: function (e) {
				var left = (e.pageX - offset.left),
					top = (e.pageY - offset.top);

				top = Math.max(Math.min(top, sourceHeight), 0);
				left = Math.max(Math.min(left, sourceWidth), 0);

				img.style.left = (left * -xRatio) + 'px';
				img.style.top = (top * -yRatio) + 'px';
			}
		};
	};

	/*
		Zoom 1.7.14
		license: MIT
		http://www.jacklmoore.com/zoom
	*/
	var zoomDefaults = {
		url: false,
		callback: false,
		target: false,
		duration: 120,
		on: 'mouseover', // other options: grab, click, toggle
		touch: true, // enables a touch fallback
		onZoomIn: false,
		onZoomOut: false,
		magnify: 1
	};
	
	// Core Zoom Logic, independent of event listeners.
	$.fn.zoom = function (options) {
		return this.each(function () {
			var
			settings = $.extend({}, zoomDefaults, options || {}),
			//target will display the zoomed image
			target = settings.target || this,
			//source will provide zoom location info (thumbnail)
			source = this,
			$source = $(source),
			$target = $(target),
			img = document.createElement('img'),
			$img = $(img),
			mousemove = 'mousemove.zoom',
			clicked = false,
			touched = false,
			$urlElement;

			// If a url wasn't specified, look for an image element.
			if (!settings.url) {
				$urlElement = $source.find('img');
				if ($urlElement[0]) {
					settings.url = $urlElement.data('src') || $urlElement.attr('src');
				}
				if (!settings.url) {
					return;
				}
			}

			(function(){
				var position = $target.css('position');
				var overflow = $target.css('overflow');

				$source.one('zoom.destroy', function(){
					$source.off(".zoom");
					$target.css('position', position);
					$target.css('overflow', overflow);
					$img.remove();
				});
				
			}());

			img.onload = function () {
				var zoom = $.zoom(target, source, img, settings.magnify);
				var tapped = false;
				function start(e) {
					zoom.init();
					zoom.move(e);

					// Skip the fade-in for IE8 and lower since it chokes on fading-in
					// and changing position based on mousemovement at the same time.
					$img.stop()
					.fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
				}

				function stop() {
					$img.stop()
					.fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
				}

				// Mouse events
				if (settings.on === 'grab') {
					$source
						.on('mousedown.zoom',
							function (e) {
								if (e.which === 1) {
									$(document).one('mouseup.zoom',
										function () {
											stop();

											$(document).off(mousemove, zoom.move);
										}
									);

									start(e);

									$(document).on(mousemove, zoom.move);

									e.preventDefault();
								}
							}
						);
				} else if (settings.on === 'click') {
					$source.on('click.zoom',
						function (e) {
							if (clicked) {
								// bubble the event up to the document to trigger the unbind.
								return;
							} else {
								clicked = true;
								start(e);
								$(document).on(mousemove, zoom.move);
								$(document).one('click.zoom',
									function () {
										stop();
										clicked = false;
										$(document).off(mousemove, zoom.move);
									}
								);
								return false;
							}
						}
					);
				} else if (settings.on === 'toggle') {
					$source.on('click.zoom',
						function (e) {
							if (clicked) {
								stop();
							} else {
								start(e);
							}
							clicked = !clicked;
						}
					);
				} else if (settings.on === 'mouseover') {
					zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.
					
					$source
						.on('mouseenter.zoom', function(e) { if(!tapped) { start(e);} })
						.on('mouseleave.zoom', stop)
						.on(mousemove, zoom.move);
				}

				// Touch fallback
				if (settings.touch) {
					var touchActivated = false;
					var touchmove = false;
					$source
						.on('touchstart', function (e) {
							if(!tapped){ //if tap is not set, set up single tap
								tapped=setTimeout(function(){
								tapped=null;
								if (touchActivated && !touchmove) {
									stop(); 
									touchActivated = false;
								}
								},300);
							} else {
								clearTimeout(tapped); 
								tapped=null;
								
								if (touchActivated) {
									touchActivated = false;
									stop();
								} else {
									touchActivated = true;
									start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
								}
							}
							//e.preventDefault();	
							
						})
						.on('touchmove', function (e) {
							touchmove = true;
							if(touchActivated) {
								console.log('preventing');
								zoom.move( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
								e.preventDefault();	
							}
						})
						.on('touchend', function (e) {
							touchmove = false;
						})
					;
				}
				
				if ($.isFunction(settings.callback)) {
					settings.callback.call(img);
				}
			};

			img.src = settings.url;
		});
	};
	$.fn.zoom.defaults = zoomDefaults;

}(jQuery));

// PURE JS FUNCTIONS

// COLOR UTILITIES

var getContrastColor = function(rgbstring)
{
	var triplet = rgbstringToTriplet(rgbstring);
	var resultColor;
	// black or white:
	var total = 0; for (var i=0; i<triplet.length; i++) { total += triplet[i]; } 
	if(total > (3*256/2)) {
		resultColor = 'black';
	} else {
		resultColor = 'white';
	}
	return resultColor;
};

var rgbstringToTriplet = function(rgbstring)
{
   if(!rgbstring.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)) {
      hex = hexToRgb(rgbstring);
		if (hex!==null) {
			rgbstring = "rgb("+hex.r+","+hex.g+","+hex.b+")";
		}
   }
   var commadelim = rgbstring.substring(4,rgbstring.length-1);
   var strings = commadelim.split(",");
   var numeric = [];
   for(var i=0; i<3; i++) { numeric[i] = parseInt(strings[i]); }
   return numeric;
};

var hexToRgb = function(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
};

// CHECK INTEGER FOR BASKET

var checkForInteger = function(input) {
   var result = true;
   var regex = /^[0-9]*$/;
   var matches = regex.exec(input);
   if (!matches) {
      result = false;
   }
   return result;
};

// SORT OF CLOTHING SIZES

var clothingSizesSortOrder = {
	"XS": 1,
	"S": 2,
	"M": 3,
	"L": 4,
	"XL": 5,
	"XXL": 6,
	"XXXL": 7
};

var clothingSizesCustomSort = function(x,y) {
	if (clothingSizesSortOrder[x]>clothingSizesSortOrder[y]) {
		return 1;
	} else {
		return -1;	
	}
	return 0;
};

function escapeRegExp(stringToGoIntoTheRegex) {
    return stringToGoIntoTheRegex.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

